exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".community-dynamics-tabs[data-v-b90c8548]{padding:20px;background-color:#fff}", ""]);

// exports
